export default __webpack_public_path__ + "static/media/entj@3x.b9ae54d4.png";